<template>
  <div id="the-footer">
    <router-link
      to="/begriffe"
      tag="div"
      role="button"
      class="footer-button"
      @click.native="retractProfile"
    >
      Begriffe erklärt
    </router-link>
    <router-link
      to="/"
      tag="div"
      role="button"
      class="footer-icon-button"
      @click.native="retractProfile"
    >
      <img src="@/assets/icon.png" alt="logo" />
    </router-link>
    <router-link
      to="/hilfe"
      tag="div"
      role="button"
      class="footer-button"
      @click.native="retractProfile"
    >
      App erklärt
    </router-link>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "TheFooter",
  methods: {
    retract() {
      this.retractProfile();
      window.scrollTo({
        top: 0,
        left: 0,
        behaviour: "smooth",
      });
    },
    ...mapActions(["retractProfile"]),
  },
};
</script>

<style lang="scss" scoped>
#the-footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px;
  position: fixed;
  bottom: 0;
  width: 100%;
  max-width: $app-max-width;
  min-width: $app-min-width;
  background-color: $blue;
  z-index: 10;
  height: $footer-height;

  .footer-icon-button {
    margin: 0 30px;
    cursor: pointer;
    img {
      width: 32px;
      height: auto;
    }
  }

  .footer-button {
    width: 45%;
    background: #ffffff;
    border: 2px solid $green;
    color: $green;
    font-weight: 400;
    transition: all 0.3s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    cursor: pointer;
    box-shadow: 0px 2px 4px #1d1d1d;

    &:hover {
      background: $green;
      color: #ffffff;
      border: 2px solid #ffffff;
    }
  }
}
</style>
